module.exports = __webpack_public_path__ + "img/lg_ring_y_c_null_0@3x.44d75023.png";